module.exports = __webpack_public_path__ + "img/two-yellow-light.a2aa5026.svg";